export default __webpack_public_path__ + "static/faqs-fc817eff5708bc2212cb2c4f989df112.jpg";